<template>
  <div>
    <van-popup
      v-model="isView"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#f5f5f5' }"
    >
      <div>
        <van-nav-bar fixed>
          <div slot="title">楼宇详情</div>
          <div slot="left" @click="close">
            <van-icon name="arrow-left" color="#333" size="19" />
          </div>
        </van-nav-bar>
        <div class="edit-wrap">
          <div>
            <van-cell-group>
              <van-cell title="楼宇名称" :value="buildRow.BuildingName" />
              <van-cell title="简称" :value="buildRow.BuildingFullName" />
              <van-cell title="校区" :value="buildRow.SchoolDistrictName" />
              <van-cell title="类别" :value="buildRow.BuildingTypeNames" />
            </van-cell-group>
            <van-cell-group>
              <van-cell title="地上楼层" :value="`共${buildRow.AboveGroundCount}层`" />
              <van-cell title="地下楼层" :value="`共${buildRow.UnderGroundCount}层`" />
              <van-cell title="是否启用" :value="`${buildRow.State ? '  已启用' : '  已停用'}`" />
            </van-cell-group>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "ViewBuild",
  props: {
    isView: Boolean,
    rows: {}
  },
  data() {
    return {
      isChecked: false,
      isState: false,
      isDelLoading: false,
      isLoading: false,
      isModal: false,
      buildname: "",
      isSchool: false,
      isType: false,
      schoolName: "",
      buildTypeName: "",
      vaildName: "",
      vaildSid: "",
      vaildType: "",
      resultList: [],
      buildRow: {},
      isUpFloor: false,
      isDownFloor: false
    };
  },
  watch: {
    rows: {
      handler(val) {
        if (val) {
          this.buildRow = val;
        }
      },
      deep: true
    },
    immediate: true
  },
  methods: {
    close() {
      this.$emit("listenToChildClose", false);
    }
  }
};
</script>
<style lang="less" scoped>
.edit-title {
  text-align: center;
  height: 80px;
  line-height: 80px;
}

.edit-wrap {
  margin-top: 110px;

  .custom-title {
    margin-left: 100px;
  }

  .tips-name {
    color: #ccc;
    font-size: 24px;
    padding-left: 20px;
    margin: 20px 0;
  }

  .group-bottom {
    margin-bottom: 20px;
  }

  .edit-build-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 120px;
    background: #ffffff;
    align-items: center;

    .btn-left {
      margin-right: 80px;
    }

    button {
      width: 30%;
    }
  }
}
</style>
